import { CommonResponse, get } from './common'

export interface AnniversaryItem {
  description: string // 일정 내용
  name: string // 일정 이름
  year: number // 년도 (2025)
  month: string // 월 (07)
  day: string // 일 (15)
  id: string // id
  type: string // 내부: 1, 외부: 2
  creationDate: string // 생성일
  downloadUrl: string | null // 다운로드 url
}

export const getAnniversaryList = async (): Promise<
  CommonResponse<{
    anniversaries: AnniversaryItem[]
  }>
> => {
  return await get('/anniversary')
}
